import { Box, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../../theme/newPost.css';

interface DescriptionStepProps {
  description: string;
  maxDescriptionChars: number;
  onChange: (description: string) => void;
}

const DescriptionStep: React.FC<DescriptionStepProps> = ({ 
  description, 
  maxDescriptionChars, 
  onChange 
}) => {
  const { t } = useTranslation();
  const isMaxLength = description.length >= maxDescriptionChars;

  return (
    <Box className="new-post-step-content">
      <TextField
        multiline
        rows={6}
        value={description}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('new_post.description_placeholder')}
        inputProps={{ maxLength: maxDescriptionChars }}
        fullWidth
        variant="outlined"
        className="new-post-text-field"
      />
      <div className={`new-post-character-count ${isMaxLength ? 'new-post-character-count-error' : ''}`}>
        <Typography variant="caption">
          {t('new_post.description_helper')}
        </Typography>
        <Typography variant="caption">
          {description.length}/{maxDescriptionChars}
        </Typography>
      </div>
    </Box>
  );
};

export default DescriptionStep;
